import {Camera, Vehicle, ViewMode} from '../types/';
import {
  SET_VEHICLES,
  TOGGLE_CAMERA,
  SEARCH,
  CHANGE_VIEW_MODE,
  TOGGLE_COLLAPSE,
  AppActionTypes
} from '../types/actions';

export const setVehicles = ( payload: { vehicles: Vehicle[], cameras: Camera[] } ) : AppActionTypes => {
  return {
    type: SET_VEHICLES,
    payload
  }
}
export const toggleCamera = ( payload: { camera: Camera, toggleTo: boolean } ) : AppActionTypes => {
  return {
    type: TOGGLE_CAMERA,
    payload
  }
}
export const search = ( searchValue: string ) : AppActionTypes => {
  return {
    type: SEARCH,
    payload: {
      searchValue
    }
  }
}
export const changeViewMode = ( viewMode: ViewMode ) : AppActionTypes => {
  return {
    type: CHANGE_VIEW_MODE,
    payload: {
      viewMode
    }
  }
}
export const toggleCollapse = ( leftPanelCollapsed: boolean ) : AppActionTypes => {
  return {
    type: TOGGLE_COLLAPSE,
    payload: {
      leftPanelCollapsed
    }
  }
}